import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, of, debounceTime, switchMap, map, catchError, first } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SsoEmailValidatorService {
  constructor(private http: HttpClient) {}

  checkSsoSupport() {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const value = (control.value || '').trim().toLowerCase();
      if (!this.isValidEmail(value)) return of(null);

      const domain = this.extractDomain(value);
      if (!domain) return of(null);

      return of(domain).pipe(
        debounceTime(400),
        switchMap(d =>
          this.http.get<{ found: boolean }>(`/validate/idp?domain=${encodeURIComponent(d)}`)
        ),
        map(response => (response.found ? null : { idpNotConfigured: true })),
        catchError(() => of({ idpCheckFailed: true })),
        first()
      );
    };
  }

  private extractDomain(email: string): string | null {
    const parts = email.split('@');
    return parts.length === 2 ? parts[1] : null;
  }

  private isValidEmail(email: string): boolean {
    const pattern =
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9-]+\.)+[a-z]{2,}$/i;
    return pattern.test(email);
  }
}
